import React from "react";
import Login from "./../../components/Login/index";
function SignIn() {
  return <Login />;
}

export default SignIn;
